import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as duplicateRecipientsActions from '../../../redux/actions/DuplicateRecipientsActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import DuplicatesTable from './DuplicatesTable';
import MergeDuplicatesModal from './MergeDuplicatesModal';
import { formatNumber } from '../../../lib/utils';

class DuplicateRecipientsPage extends NavigationComponent {
    //will pagination complicate things???  what happens once they merge and they disappear???  

    //all duplicates stay until they request 'findDuplicates' - which happens on page refresh and if click 'refresh duplicates'
    //when merge it, all it does is marks it 'merged', doesn't remove it - otherwise pagination will get messed up
    //we need to keep in state whether it was merged bec need to keep track until it's re-requested
    //disable once merged, but leave there


    //OR shud we re-request the page each time they merge?  maybe let's  do that!
    //separate request to find and get!!!!!!!!!  IMPT TO KNOW THIS!  DON'T SHOW TABLE TILL FOUND RETURNS SUCCESS!!!! THEN GET...

    //PLAN
    //if merge, clears it out on backend (does not run refind!), and re-request the page we're on!
    //find -finds them!  get does NOT find them!

    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                mergeDuplicatesModal: false
            }
        };
    }

    componentWillMount() {
        this.props.actions.findDuplicateRecipients();
        //handle failure!!! (loading)
    }

    viewDuplicatesDetails = recipientIds => {
        this.props.actions.getDuplicateRecipientsDetails(recipientIds[0], recipientIds[1]);
        this.toggleModal("mergeDuplicatesModal");
    }

    render() {
        return (
            <div className="page manage-duplicates">
                <div className="subheader">
                    <div className="container flex-justify">
                        <h2 className="page-header">Manage Duplicates
                            {this.props.duplicateRecipientsTable.data.totalCount > 0
                                && <span className="duplicate-tag">{formatNumber(this.props.duplicateRecipientsTable.data.totalCount)}</span>}
                        </h2>
                        {/* Refresh Button! */}
                        <div className="back-link">
                            <i className="icon ion-android-arrow-back middle medium-text"></i>
                            <Link to="/recipient-accounts" className="link-text small-text">Back to Recipients</Link>
                        </div>
                    </div>
                </div>

                {this.props.findingDuplicates.loading
                    ? <LoadingSpinner height="30" />
                    : <DuplicatesTable
                        {...this.props.duplicateRecipientsTable}
                        updateTable={this.props.actions.updateTable}
                        getDuplicates={this.props.actions.getDuplicateRecipients}
                        viewDuplicatesDetails={this.viewDuplicatesDetails}
                    />}


                <MergeDuplicatesModal
                    show={this.state.showModals.mergeDuplicatesModal}
                    close={() => this.toggleModal("mergeDuplicatesModal")}
                    duplicatesDetails={this.props.duplicatesDetails}
                    mergeDuplicates={this.props.actions.resolveDuplicateRecipients}
                    mergingDuplicates={this.props.resolvingDuplicates} />

            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        ...state.duplicateRecipients,
        duplicateRecipientsTable: state.duplicateRecipientsTable
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(duplicateRecipientsActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateRecipientsPage);


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/manageDuplicates/DuplicateRecipientsPage.jsx